import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin, Briefcase } from "lucide-react";

const TeamData = [
  {
    img: "/careers/customer_service.png",
    title: "พนักงาน บริการลูกค้า",
    loc: "ประจำภูมิภาค ทุกจังหวัด",
    salary: "15,000 – 20,000 บาท",
    tags: ["Field Work", "ทุกจังหวัด", "มีรถประจำตำแหน่ง"],
    sections: [
      {
        heading: "หน้าที่ความรับผิดชอบ",
        items: [
          "เข้าเก็บข้อมูล ถ่ายรูปบ้าน รับเอกสารจากเจ้าของบ้าน",
          "พาลูกค้าไปทำธุรกรรมที่ สนง.ที่ดิน",
          "ช่วยเหลือให้คำแนะนำลูกค้ายื่นกู้ซื้อบ้านกับธนาคาร",
        ],
      },
      {
        heading: "คุณสมบัติ",
        items: [
          "มีความซื่อสัตย์ สุจริต",
          "มี Service Mind รักงานบริการ อัธยาศัยดี",
          "ขับรถได้ มีใบอนุญาตขับขี่",
          "พร้อมเรียนรู้เทคโนโลยี เช่น แอปถ่ายรูป 3D",
          "ไม่จำกัดเพศ อายุไม่เกิน 45 ปี",
          "วุฒิการศึกษา ม.6 ขึ้นไป ไม่จำกัดสาขา",
        ],
      },
      {
        heading: "ผลตอบแทน",
        items: [
          "เงินเดือน 15,000 – 20,000 บาท",
          "ค่าคอมปิดการขาย หลังละ 1,000 – 3,000 บาท",
          "รถประจำตำแหน่ง 1 คัน พร้อมน้ำมัน",
          "เครื่องแบบพนักงาน",
          "ประกันสังคม + ประกันชีวิต",
          "ท่องเที่ยวประจำปี + โบนัสตามผลประกอบการ",
        ],
      },
    ],
  },
  {
    img: "/careers/call_center.png",
    title: "พนักงาน Call Center",
    loc: "Work from Anywhere",
    salary: "15,000 – 20,000 บาท",
    tags: ["Remote", "Work from Anywhere", "มีโทรศัพท์ให้"],
    sections: [
      {
        heading: "หน้าที่ความรับผิดชอบ",
        items: [
          "รับสายลูกค้า ตอบปัญหา แนะนำบริการของบริษัท",
          "ประสานงาน แก้ปัญหาผ่านระบบ",
        ],
      },
      {
        heading: "คุณสมบัติ",
        items: [
          "รักงานบริการ มีไหวพริบ แก้ปัญหาเฉพาะหน้าได้ดี",
          "ใช้ภาษาสุภาพ พูดจาเพราะ น้ำเสียงน่าฟัง",
          "พร้อมเรียนรู้เสมอ",
          "วุฒิการศึกษา ม.6 ขึ้นไป ไม่จำกัดสาขา",
          "ไม่จำกัดเพศ อายุไม่เกิน 45 ปี",
        ],
      },
      {
        heading: "ผลตอบแทน",
        items: [
          "เงินเดือน 15,000 – 20,000 บาท",
          "ค่าคอมปิดการขาย หลังละ 500 – 3,000 บาท",
          "โทรศัพท์ + APP ระบบ Call Center",
          "เลือกสถานที่ทำงานได้หลังผ่านทดลองงาน",
          "ประกันสังคม + ประกันชีวิต",
          "ท่องเที่ยวประจำปี + โบนัสตามผลประกอบการ",
        ],
      },
    ],
  },
  {
    img: "/careers/admin.png",
    title: "พนักงาน Admin",
    loc: "Work from Home",
    salary: "15,000 – 20,000 บาท",
    tags: ["Remote", "ทำงานที่บ้านได้", "ยินดีรับผู้พิการ"],
    sections: [
      {
        heading: "หน้าที่ความรับผิดชอบ",
        items: [
          "Monitor ข้อมูล online เกี่ยวกับบริษัทฯ ด้วย Social Listening",
          "รับเรื่องร้องเรียน ข้อแนะนำจากลูกค้า",
          "ดูแล update ข้อมูลข่าวสารบนสื่อ online",
          "ติดตามข่าวสารวงการอสังหาฯ วิเคราะห์และนำมาใช้ประโยชน์",
        ],
      },
      {
        heading: "คุณสมบัติ",
        items: [
          "มีความซื่อสัตย์และมีความรับผิดชอบสูง",
          "สนใจโลก online ใช้เครื่องมือ Social Listening เป็น",
          "ไม่จำกัดวุฒิ อายุ เพศ (เน้นความสามารถและทัศนคติ)",
          "กระตือรือร้น พร้อมเรียนรู้เสมอ",
          "ยินดีรับผู้พิการทางร่างกายที่สามารถทำหน้าที่นี้ได้",
        ],
      },
      {
        heading: "ผลตอบแทน",
        items: [
          "เงินเดือน 15,000 – 20,000 บาท",
          "โทรศัพท์ + Computer Notebook ให้ใช้งาน",
          "ทำงานที่บ้านได้",
          "ประกันสังคม + ประกันชีวิต",
          "ท่องเที่ยวประจำปี + โบนัสตามผลประกอบการ",
        ],
      },
    ],
  },
];

export default function JoinTeam() {
  return (
    <div className="min-h-screen bg-gray-50 lg:pt-20">
      <div className="max-w-5xl mx-auto px-4 py-8 lg:py-12 space-y-4">

        {/* ── Header card ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/contact">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div className="w-9 h-9 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
            <Briefcase className="w-4 h-4 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">ร่วมงานกับเรา</p>
            <h1 className="text-lg font-bold text-gray-900">ตำแหน่งงานที่เปิดรับ</h1>
          </div>
        </motion.div>

        {/* ── Job cards ── */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {TeamData.map((job, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06, ease: "easeOut" }}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col"
            >
              {/* Image */}
              <div className="h-48 overflow-hidden flex-shrink-0 bg-gray-50 flex items-center justify-center">
                <img
                  src={job.img}
                  alt={job.title}
                  className="w-full h-full object-contain scale-90"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">

                {/* Title + location */}
                <div className="mb-3">
                  <h2 className="text-base font-bold text-gray-900 leading-snug">{job.title}</h2>
                  <div className="flex items-center gap-1.5 mt-1">
                    <MapPin className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                    <span className="text-xs text-gray-500">{job.loc}</span>
                  </div>
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {job.tags.map((tag, ti) => (
                    <span key={ti} className="text-xs px-2.5 py-1 bg-gray-50 border border-gray-100 rounded-full text-gray-600 font-medium">
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Sections */}
                <div className="space-y-3 flex-1">
                  {job.sections.map((sec, si) => (
                    <div key={si}>
                      <div className="flex items-center gap-2 mb-1.5">
                        <div className="w-px h-3 bg-blue-400 rounded-full" />
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{sec.heading}</p>
                      </div>
                      <ul className="space-y-1 pl-3">
                        {sec.items.map((item, ii) => (
                          <li key={ii} className="text-xs text-gray-600 leading-relaxed flex gap-1.5">
                            <span className="text-gray-300 flex-shrink-0 mt-0.5">•</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                {/* Salary + Apply button */}
                <div className="mt-5 pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between mb-3">
                    <p className="text-xs text-gray-400">เงินเดือน</p>
                    <p className="text-sm font-bold text-emerald-600">{job.salary}</p>
                  </div>
                  <Link to="https://forms.gle/rhjJJ7X5iqE7aLrF8" target="_blank">
                    <div className="w-full py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors flex items-center justify-center gap-1.5">
                      สมัครตำแหน่งนี้
                      <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* ── Bottom note ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.25, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-6 py-5 flex items-center gap-4"
        >
          <div className="flex-1">
            <p className="text-sm font-semibold text-gray-800">มีคำถามเพิ่มเติม?</p>
            <p className="text-xs text-gray-400 mt-0.5">ติดต่อทีมงานผ่าน Line OA : <span className="text-blue-600 font-medium">@postperty</span></p>
          </div>
          <Link to="/contact">
            <div className="flex items-center gap-1.5 px-4 py-2.5 bg-gray-50 border border-gray-200 text-gray-700 text-xs font-semibold rounded-xl hover:bg-gray-100 transition-colors whitespace-nowrap">
              ดูช่องทางติดต่อ
              <ArrowUpRight className="w-3.5 h-3.5" />
            </div>
          </Link>
        </motion.div>

      </div>
    </div>
  );
}
